<template>
  <div>
    <portal to="WorkloadHeaderLeftSide">
      <h3 class="primary--text mr-4">
        {{ countryName }}
      </h3>

      <div>
        {{ $t('Country Workload And Shortage') }}
      </div>
    </portal>

    <!--    <portal to="WorkloadHeaderRightSide">-->
    <!--    </portal>-->

    <CountryWorkloadForm />
  </div>
</template>

<script>

    // TODO: Add check access

    import CountryWorkloadForm from "@/components/workload/CountryWorkloadForm";

    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        name: "CountryWorkload",

        components: {
            CountryWorkloadForm
        },

        computed: {
            countryId() {
                return this.$route.params.countryId
            },

            countryName() {
                return this.country?.name || ''
            },

            ...mapGetters('countries', [
                'country'
            ])
        },

        async created() {
            try {
                this.setGlobalLoading(true);
                await this.getOne({id: this.countryId})
            } catch (e) {
                console.error(e)
            } finally {
                this.setGlobalLoading(false);
            }
        },

        destroyed() {
            this.setCountry(null)
        },

        methods: {
            ...mapMutations([
                'setGlobalLoading'
            ]),

            ...mapMutations('countries', [
                'setCountry'
            ]),

            ...mapActions('countries', [
                'getOne'
            ])
        }


    }
</script>

<style scoped>

</style>
